
const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7074/api/',
    //Live

    //DEV


    // Live
    apiUrl: 'https://cf-api-new.solegaze.com/api/',

    apiKey: 'Lieda1002',
};

export default apiConfig;

